// extracted by css-extract-rspack-plugin
export default {"container":"YzwBMbtWrtIJbvF2","statusWrapper":"DBPL8YEfcs4IkOVV","editButton":"MJrvGvydRocvJxUN","linkButton":"Zfv2ldOgEBeXVQZw","submitButton":"BuIb4ZeaLsgvieE3"};